import { useAxios } from "api/useAxios";
import axios from "axios";
import { EndPoint } from "data/endPoint";
import { LoginInfo, LoginParams } from "types/feature/login/login";
import { ApkDownloadType } from "types/feature/ripeness/ripeness";

// import { setLocalStorage } from 'utils/localStorage-utils';

export const useAuth = () => {
  const { api } = useAxios();
  // const { setAuthenticationInfo } = authStore();

  const postLogin = async ({ username, password }: LoginParams) => {
    try {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);
      const result = await axios.post<LoginInfo>(`${process.env.REACT_APP_BASE_URL}${EndPoint.login}`, formData);
      // storeAuthenticationInfo(data);
      return result;
    } catch (e) {
      // TODO: 로그인 실패 처리
    }
  };

  // valid picture 조회
  const getDownloadApkUrl = async () => {
    return await api.get<ApkDownloadType>(`${EndPoint.apk}`);
  };

  return {
    postLogin,

    getDownloadApkUrl,
  };
};
